export default function useMessageScroll() {
    function scrollToBottom() {
        const container = document.getElementById("ChatMessageList");

        if (!container) return;
        container.scrollTo(0, container.scrollHeight);
    }

    function scrollToMessage(messageId: string) {
        document.getElementById(messageId)?.scrollIntoView({
            block: "nearest"
        });
    }

    return {
        scrollToBottom,
        scrollToMessage
    };
}
